import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import TckAffidavit from '../components/TckAffidavit.vue'

Vue.use(VueRouter)

const routes = [
  {path: '/tck-affidavit', component: TckAffidavit },
  {path: '/', redirect: '/index' },
  {path: '/index', component: Home },
]

// eslint-disable-next-line no-new
const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
